import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

import PMEISidePanelContent from './PMEISidePanelContent';
import PMEISidepanelHeader from './PMEISidepanelHeader';
import usePMEISidepanelDetail from './usePMEISidepanelDetail';
import {UnitOperationFields} from './useUnitOpLinkingState';

export default function PMEISidePanel({unitOperation}: {unitOperation: UnitOperationFields}): JSX.Element {
  const detail = usePMEISidepanelDetail(unitOperation.pmeiId);

  return (
    <div {...getTestProps({component: 'PMEISidePanel', element: 'root'})}>
      <PMEISidepanelHeader unitOperation={unitOperation} />
      <PMEISidePanelContent detailData={detail.data} />
    </div>
  );
}
